import { INSURANCE_ID } from '@/common/biz/constants'
import type { InsuranceInfoRes } from 'api/api-type'

export function getInsuranceStatus(insuranceData: InsuranceInfoRes['insurance_data']): number {
  let insuranceStatus = -1
  try {
    if (insuranceData.insurance_status) {
      insuranceStatus = insuranceData.insurance_status[INSURANCE_ID]
    } else if (insuranceData.policy_data) {
      insuranceStatus = insuranceData.policy_data[INSURANCE_ID]?.policy_status || 0
    } else {
      insuranceStatus = 0
    }
  } catch {
    insuranceStatus = 0
  }
  return insuranceStatus
}
